export enum InitialAnalysisStatus {
  PENDING = 'pending',
  DENIED = 'denied',
  APPROVED = 'approved'
}

export enum QuantitativeScoreRating {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export enum ProposalRisk {
  DENIED = 'denied',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  VERY_LOW = 'veryLow'
}

export enum QuantitativeScoreStepName {
  FOUNDING_AGE = 'foundingAge',
  FOUNDING_DATE = 'foundingDate',
  QUALIFY_PARTNERSHIP_ENTRY_DATE = 'qualifyPartnershipEntryDate',
  ACTIVITIES = 'activities',
  SCORE_PF_PJ = 'scorePFandPJ',
  INDEBTEDNESS_BEHAVIOR = 'indebtednessBehavior',
  INDEBTEDNESS_TYPE = 'indebtednessType',
  RESTRICTIONS = 'restrictions',
  HSPN_SERASA_RESTRICTION = 'hspnSerasaRestriction'
}
